import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'carbon-components-react';
import {
  AreaCustom16,
  FlowData16,
  Cursor_116,
  TrashCan16
} from '@carbon/icons-react';

const DrawingTool: React.FC<Props> = ({
  activeTool,
  allButtonDisabled,
  removeButtonDisabled,
  onClickTools
}) => {
  return (
    <div className="drawTools-container">
      <Button
        renderIcon={Cursor_116}
        iconDescription="Move"
        tooltipPosition="bottom"
        hasIconOnly
        kind="ghost"
        size="field"
        disabled={allButtonDisabled}
        className={`${activeTool === 'selector' ? ' active-map-tool' : ''}`}
        onClick={() => onClickTools('selector')}
      />
      <Button
        renderIcon={FlowData16}
        iconDescription="Draw Line"
        tooltipPosition="bottom"
        hasIconOnly
        kind="ghost"
        size="field"
        disabled={allButtonDisabled}
        className={`${activeTool === 'polyline' ? ' active-map-tool' : ''}`}
        onClick={() => onClickTools('polyline')}
      />
      <Button
        renderIcon={AreaCustom16}
        iconDescription="Draw Polygon"
        tooltipPosition="bottom"
        hasIconOnly
        kind="ghost"
        size="field"
        disabled={allButtonDisabled}
        className={`${activeTool === 'polygon' ? ' active-map-tool' : ''}`}
        onClick={() => onClickTools('polygon')}
      />
      <Button
        renderIcon={TrashCan16}
        iconDescription="Remove"
        tooltipPosition="bottom"
        hasIconOnly
        kind="ghost"
        size="field"
        disabled={allButtonDisabled || removeButtonDisabled}
        onClick={() => onClickTools('remove')}
      />
    </div>
  );
};

const propTypes = {
  activeTool: PropTypes.string,
  allButtonDisabled: PropTypes.bool,
  removeButtonDisabled: PropTypes.bool,
  onClickTools: PropTypes.func.isRequired
};

type Props = PropTypes.InferProps<typeof propTypes>;

DrawingTool.propTypes = propTypes;

DrawingTool.defaultProps = {
  activeTool: 'selector',
  removeButtonDisabled: false,
  allButtonDisabled: false
};

DrawingTool.displayName = 'AoiDrawingTool';

export default React.memo(DrawingTool);
